import { api } from "../api/api";
import { ApiResponse } from "../models/base/ApiResponse";
import { CreateTagDTO, UpdateTagDTO } from "../models/tag/tag.request";
import { TagInfoDTO, TagSettingsDTO, TagTableSettingsDTO } from "../models/tag/tag.response";



export const tagService = {

    async create(tag: CreateTagDTO): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>(`/tags`, tag);
        return data;
    },

    async update(tagId: string, tag: UpdateTagDTO): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/tags/${tagId}`, tag);
        return data;
    },

    async delete(tagId: string): Promise<ApiResponse<string>> {
        const { data } = await api.delete<ApiResponse<string>>(`/tags/${tagId}`);
        return data;
    },

    async getAll(): Promise<ApiResponse<TagInfoDTO[]>> {
        const { data } = await api.get<ApiResponse<TagInfoDTO[]>>(`/tags`);
        return data;
    },

    async getById(tagId: string): Promise<ApiResponse<TagSettingsDTO>> {
        const { data } = await api.get<ApiResponse<TagSettingsDTO>>(`/tags/${tagId}/settings`);
        return data;
    },

    async getForTable(): Promise<ApiResponse<TagTableSettingsDTO[]>> {
        const { data } = await api.get<ApiResponse<TagTableSettingsDTO[]>>(`/tags/settings/table`);
        return data;
    }


}